import { jsxs as r, jsx as o } from "react/jsx-runtime";
import { SvgIcon as t } from "../SvgIcon.js";
const p = (m) => /* @__PURE__ */ r(t, { ...m, children: [
  /* @__PURE__ */ o("path", { d: "m17.0735 15.8365-4.7598-4.7598c.6405-.8945 1.016-1.97676 1.016-3.15843 0-2.99282-2.4296-5.41137-5.41137-5.41137-2.99282 0-5.41137 2.42959-5.41137 5.41137 0 2.98173 2.42959 5.41133 5.41137 5.41133 1.18167 0 2.26397-.3754 3.15847-1.016l4.7598 4.7598 1.2369-1.2369Zm-12.91-7.91823c0-2.0762 1.67863-3.75483 3.75483-3.75483s3.75487 1.67863 3.75487 3.75483-1.67867 3.75483-3.75487 3.75483S4.1635 9.98343 4.1635 7.91827Z" }),
  /* @__PURE__ */ o("path", { d: "M10.4141 7.28883H8.5367V5.42245H7.28877v1.86638H5.42239v1.24793h1.86638v1.87744H8.5367V8.53676h1.8774V7.28883Z" })
] });
export {
  p as ZoomIn
};
//# sourceMappingURL=ZoomIn.js.map
